<template>
  <div id="flame">
    <div>
      <div id="toolbar" class="ui menu">
        <a class="item">Acroファイル交換サービス</a>
        <div class="right menu">
          <div id="exchangeMain-menu" class="ui dropdown item" @click="toggleMenu">
            {{username}}
            <i class="dropdown icon"></i>
            <div class="menu" :style="{display:!!openedMenu?'block':'none'}">
              <a id="exchangeMain-menu__logout" class="item" @click="logout">ログアウト</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="main">
      <div id="sidebar" class="ui vertical menu">
        <router-link
          id="exchangeMain-exchange"
          tag="a"
          class="item"
          :to="{ name: 'exchangeList' }"
        >ファイル交換履歴</router-link>
        <router-link id="exchangeMain-upload" tag="a" class="item" :to="{ name: 'upload' }">ファイル送付</router-link>
        <router-link
          id="exchangeMain-request"
          tag="a"
          class="item"
          :to="{ name: 'exchangeRequest' }"
        >ファイル引取依頼</router-link>
        <div v-if="isAdmin">
          <router-link
            id="exchangeUsage-status"
            tag="a"
            class="item"
            :to="{ name: 'exchangeUsage' }"
          >ファイル交換利用状況</router-link>
        </div>
      </div>
      <div id="content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import { getUsername, signOut, currentLoggedInUser } from '@/auth'

export default {
  data: function () {
    return {
      username: '',
      openedMenu: false,
      isAdmin: false
    }
  },
  created: function () {
    getUsername().then(username => {
      this.username = username
    })
    var instance = this
    currentLoggedInUser().then(data => {
      if (
        data['attributes']['custom:tenantRole'] &&
        data['attributes']['custom:tenantRole'] === 'admin'
      ) {
        instance.isAdmin = true
      } else {
        instance.isAdmin = false
      }
    })
  },
  methods: {
    logout: function () {
      this.$store.commit('progress/setLoading', true)
      signOut().catch(() => {
        this.$store.commit('progress/setLoading', false)
        this.$store.commit('infoModal/openModal', {
          type: 'ERROR',
          title: 'ログアウト',
          message:
            'ログアウトに失敗しました。\nしばらくしてからもう一度お試しください。'
        })
      })
    },
    toggleMenu: function () {
      this.openedMenu = !this.openedMenu
    }
  }
}
</script>
<style>
#flame {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

#main {
  flex: 1;
  display: flex;
}

#content {
  flex: 1;
  padding: 20px 10px 20px 10px;
  height: calc(100vh - 44px);
  overflow: auto;
}
</style>
